module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.ebaf8851.png";